import type { MarketPhase } from "~/v2/api/rest/data";

export type MarketStatusPillColor = "green" | "gray" | "amber";

export interface MarketStatusPillData {
  label: string;
  color: MarketStatusPillColor;
}

const PHASE_PILLS: Record<MarketPhase, MarketStatusPillData> = {
  core: { label: "Market open", color: "green" },
  closed: { label: "Market closed", color: "gray" },
  pre: { label: "Pre-market", color: "amber" },
  post: { label: "Extended hours", color: "amber" },
  overnight: { label: "Overnight", color: "amber" },
};

export const phaseToPill = (
  phase: MarketPhase | undefined,
): MarketStatusPillData | null => {
  if (!phase || !Object.hasOwn(PHASE_PILLS, phase)) {
    return null;
  }

  return PHASE_PILLS[phase];
};
